/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturMercuryIcon20Solid = forwardRef('KonturMercuryIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.006 12.024a2.562 2.562 0 1 1 5.124 0 2.562 2.562 0 0 1-5.124 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.262 1.713C12.43.94 11.518.398 10.92.915L3.254 7.536a.826.826 0 0 0-.087.087 6.226 6.226 0 1 0 9.06 8.52.815.815 0 0 0 .053-.056l6.855-8.07c.501-.59-.016-1.483-.777-1.342l-3.596.666 2.588-4.745c.406-.744-.44-1.541-1.158-1.092l-4.495 2.809.565-2.6Zm-4.694 6.25a4.062 4.062 0 1 0 0 8.123 4.062 4.062 0 0 0 0-8.124Z" })));
});
